import { Environment } from "./AppConfigSlice.js";

class FeatureFlagProvider {
  isSurveyEnabled(environment: Environment) {
    return false;
  }
}

export const featureFlagProvider = new FeatureFlagProvider();
